import React from "react";
import { Button, Col } from "react-bootstrap";

const SuccessfulImport = ({ organizationName }) => {
  return (
    <div className="card">
      <div className="card-header">The import have been successfully made!</div>
      <div className="card-block">
        <Button
          size="sm"
          onClick={() => {
            window.location.href = `/organizations/${organizationName}/residents`;
          }}
        >
          Go to residents
        </Button>
      </div>
    </div>
  );
};

export default SuccessfulImport;
